import { availableFormatters } from '../utils/formatters';

// Formatting rules shown in the display-template editor are DERIVED from the
// formatter registry (src/utils/formatters.js) so there is a single source of
// truth: add a formatter there and it appears in the editor menus for its
// data types automatically.

const DEFAULT_RULE = {
	key: 'plain',
	formatterName: null,
	displayLabel: 'Default',
	description: 'Insert the value without formatting',
	args: [],
};

const KNOWN_DATA_TYPES = [
	'text-small', 'text-large', 'rich-text', 'choice', 'url',
	'number', 'decimal', 'integer', 'rating',
	'date', 'date-time', 'time',
	'measurement', 'currency', 'boolean',
	'phone', 'email', 'location',
	// A user token renders the account's display name (the API resolves it
	// at write time), so it takes the text rules.
	'user',
	// A color token is its "#rrggbb" text; a title shows the hex.
	'color',
];

const toRule = (formatter) => ({
	key: formatter.name,
	formatterName: formatter.name,
	displayLabel: formatter.label,
	description: formatter.description,
	args: (formatter.args || []).map(arg => ({
		name: arg.name,
		label: arg.label,
		type: arg.type || 'text',
		placeholder: arg.placeholder ?? (arg.defaultValue !== undefined ? String(arg.defaultValue) : ''),
		required: !arg.optional,
		defaultValue: arg.defaultValue,
	})),
});

const buildRulesForType = (dataType) => ([
	DEFAULT_RULE,
	...availableFormatters
		.filter(f => !f.menuTypes || f.menuTypes.includes(dataType))
		.map(toRule),
]);

const DATA_TYPE_RULES = Object.fromEntries(
	KNOWN_DATA_TYPES.map(type => [type, buildRulesForType(type)])
);

// Unknown/legacy data types get the text rules.
DATA_TYPE_RULES.default = DATA_TYPE_RULES['text-small'];

export const getFormattingRulesForType = (dataType) => {
	return DATA_TYPE_RULES[dataType] || DATA_TYPE_RULES.default;
};

export const DEFAULT_FORMAT_RULE_KEY = DEFAULT_RULE.key;
